import createDataState from './defaultState'
import actions from './actions.js'
import getters from './getters.js'
import mutations from './mutations.js'

const state = createDataState()

export default {
  state: () => state,
  mutations,
  actions,
  getters
}
